import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FeatureFlagGuard } from 'app/core';
import { FeatureFlag } from 'app/core/enums/feature-flag';
import { DispositionsIndexComponent } from './index.component';

const routeBase = {
  canActivate: [FeatureFlagGuard],
  component: DispositionsIndexComponent,
  data: {
    featureFlag: FeatureFlag.DISPOSITIONS_TAB,
    redirectToReplacedCurrentUrl: new RegExp('/dispositions.*'),
  },
};

const routes: Routes = [
  {
    path: '',
    ...routeBase,
    children: [
      {
        path: ':id',
        ...routeBase,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DispositionRoutingModule {}
